import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import IndividualRatings from "./components/IndividualRatings";
import OverallRatings from "./components/OverallRatings";
import PageHeader from "./components/PageHeader";
import { RatingsProvider } from "./contexts/Ratings";

const Ratings = (): React.JSX.Element => {
    return (
        <div data-testid="ratingsContent">
            <Container fluid="xs">
                <Row>
                    <Col>
                        <RatingsProvider>
                            <PageHeader />
                            <OverallRatings />

                            <h2>Individual Ratings</h2>
                            <IndividualRatings />
                        </RatingsProvider>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Ratings;
